<template>
    <div :class="this.hasReferred ? 'input-disabled' : 'input-active' ">
        <label class="checker-export-options__checkbox-container">
            <FormulateInput v-model="sendReferral" type="checkbox"
                label="Would you like to be contacted by our IP partners?"
                :outer-class="['checker-export-options__outer-checkbox-wrapper']"
                :wrapper-class="['formulate-input-wrapper--checkbox']"
                :element-class="['formulate-input-element--checkbox-small', 'checker-export-options__checkbox-wrapper']"
                :label-class="['checker-export-options__contained-checkbox-label']" 
                />
        </label>
    </div>
</template>

<script>

export default {
    name: 'CheckerReferralTool',
    props: {
        hasReferred: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            sendReferral: false
        }
    },
    watch: {
        sendReferral:function(currentValue) {
            this.$emit('referral-updated', currentValue);
        }
    }
}


</script>